<template>
    <div>
      <BannerImg
        bannerPosition="JJFA_BANNER"
        showZiXun
        :title="titleData.title"
        :subTitle="titleData.subTitle"
      >
        <template v-slot:subList>
          <section class="m-auto hidden lg:block w-full header-float">
            <div
              style="
                height: 16px;
                width: 4px;
                gap: 0px;
                opacity: 0px;
                background: #d7000f;
                float: left;
                margin-right: 10px;
                margin-top: 4px;
              "
            ></div>
            <div
              style="
               
                font-size: 16px;
                font-weight: 500;
                line-height: 24px;
                text-align: left;
                color: #000000;
                margin-bottom: 20px;
              "
            >
              热门方案
            </div>
            <div class="contantOther">
              <div
                style="justify-content: space-between;"
                class="max-w-screen-xl flex flex-wrap items-center"
              >
                <div
                  v-for="(child, childIndex) in listTitle"
                  :key="childIndex"
                  class="text-left"
                  style="margin-bottom: 12px;"
                >
                  <div class="box" @click="handleDetailsClick(child)">
                    <div class="label">
                      {{ child.solutionTitle }}
                      <div>热门</div>
                    </div>
                    <div class="desc hidden-3">
                      <show-overf-low-tooltip>
                        {{ child.schemeIntroduction }}
                      </show-overf-low-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </template>
      </BannerImg>
  
      <div class="solution-container" style="margin-top: 120px">
        <div class="solution-head" style="text-align: center">
          <el-row class="w-full flex justify-center">
            <el-col
            
              :xs="8"
              :md="3"
              :lg="2"
              v-for="(item, index) in list"
              :key="index"
              :class="{ active: active == index }"
            >
              <span
              style="cursor: pointer"
                class="solution-head-title"
                @click="handlePositionClock(index)"
                >{{ item.dictLabel }}</span
              >
            </el-col>
          </el-row>
        </div>
        <div class="solution-contant">
          <div style="width: 1280px;" v-for="(item, index) in [list[this.active]]" :key="index">
            <div :id="`id${index}`" style="height: 20px"></div>
            <!-- <div class="solution-contant-title">
              <span></span>
              <span>{{ item.dictLabel }}</span>
            </div> -->
            <main justify="center" style="display: flex; justify-content: space-between;flex-wrap: wrap;">
              <section
                v-for="(child, childIndex) in page"
                :key="childIndex"
                style="margin-bottom: 15px; width: 632px"
              >
                <EiiCard
                  :info="{
                    id: child.id,
                    img: child.schemeCover,
                    title: child.solutionTitle,
                    subTitle: child.schemeIntroduction,
                  }"
                  :handle-details-click="handleDetailsClick"
                  :key="child"
                />
              </section>
            </main>
          </div>
          <el-pagination
            style="text-align: center; margin-top: 60px;"
            background
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :total="
              (this.list[this.active] || { serviceList: [] }).serviceList.length
            "
          />
        </div>
      </div>
      <div  v-if="showButton" class="to-top" @click="totop()">
      <img src="../assets/images/totop.png" alt="" />
    </div>
    </div>
  </template>
  
  <script>
  import { listSolutionAll, listBanner } from "@/api";
  import EiiCard from "./EiiCard.vue";
  import BannerImg from "@/components/BannerImg.vue";
  
  export default {
    name: "Solution",
    components: { EiiCard, BannerImg },
    data() {
      return {
         // 返回顶部按钮
      showButton: false,
        active: 0,
        list: [],
        listTitle: [],
        page: [],
        pageSize: 10,
        titleData: {},
        sourceType: "img",
        bannerImg: "",
        bannerPath: "",
        video: "",
      };
    },
    created() {
      this.getList();
    },
    beforeDestroy() {
    window.removeEventListener('scroll',  this.handleScroll);  
  },
  mounted() {
    window.addEventListener('scroll',  this.handleScroll);  
  },
    methods: {
      totop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // 使滚动效果平滑
      });
    },
    handleScroll() {
      this.showButton  = window.scrollY  > 200; 
    },
      handleCurrentChange(number) {
        const start = (number - 1) * this.pageSize;
        this.page = this.list[this.active].serviceList.slice(
          start,
          start + this.pageSize
        );
      },
      getList() {
        listSolutionAll({ useFlag: "1" }).then((res) => {
          this.list = res.data;
          // 暂时取前6个
          this.list.forEach((i) => {
            this.listTitle = this.listTitle.concat(i.serviceList);
          });
          this.listTitle = this.listTitle.splice(0, 6);
          this.handleCurrentChange(1);
        });
      },
      handlePositionClock(index) {
        this.active = index;
        this.handleCurrentChange(1);
        // this.$el.querySelector(`#id${index}`).scrollIntoView({
        //   behavior: 'smooth',  // 平滑过渡
        //   block: 'start'
        // })
      },
      handleDetailsClick(item) {
        this.$router.push({
          path: "SolutionDetails",
          query: { id: item.id, index: 2 },
        });
        // console.log(item);
        // if (item.path.length != 0) {
        //   this.$router.push({ path: item.path, query: { name: item.name, index: 2 } })
        // }
      },
      async getBanner() {
        const res = await listBanner({ bannerPosition: "JJFA_BANNER" });
  
        this.titleData.title = res.rows[0].title;
        this.titleData.subTitle = res.rows[0].subTitle;
  
        const data = res.rows.find(
          (v) =>
            (v.bannerImg && v.sourceType == "img") ||
            (v.video && v.sourceType == "video")
        );
        if (!data) return;
        console.log(data);
        this.sourceType = data.sourceType;
        this.bannerImg = data.bannerImg;
        this.video = data.video;
        this.bannerPath = data.link;
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .el-col-md-3:first-of-type{
    width: 11% !important;
  }
  .to-top {
  cursor: pointer;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  border-radius: 5px;
  // border: 1px solid #ccc;
  position: fixed;
  z-index: 9999999;
  bottom: 100px;
  right: 100px;
  background-color: #fff;
  box-shadow: 0px 0px 8px 2px #ccc;
  img {
    width: 50%;
    height: 50%;
  }
}
  .main-p {
    display: inline-flex;
    max-width: 1280px;
    padding: 20px;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  
  .header-float {
    border: 2px solid var(--Color-2, #fff);
    background: linear-gradient(0deg, #fff 0%, #fffbfb 100%);
    /* 投影/02 */
    box-shadow: 0px 5px 18px 0px rgba(40, 41, 61, 0.07);
    height: 242px;
    width: 1280px;
    margin-top: 152px;
    box-shadow: 0px 5px 18px 0px #28293d12;
    padding: 20px;
    overflow: hidden;
  }
  .tooltip-root {
          -webkit-line-clamp: 2 !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          display: -webkit-box !important;
          -webkit-box-orient: vertical !important;
          white-space:initial !important
        }
  .contantOther {
    .box {
      height: 71px;
      width: 397px;
      gap: 9px;
      margin-bottom: 10px;
      cursor: pointer;
  
      .label {
       
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        text-align: left;
        margin-bottom: 9px;
        color: #333;
        display: inline-block;
  
        > div {
          display: inline-block;
          width: 40px;
          height: 22px;
          text-align: center;
          background: #f64041;
          border-radius: 2px 2px 2px 0px;
          color: #ffffff;
         
          font-size: 12px;
          font-weight: 400;
          margin-left: 8px;
        }
      }
  
      .desc {
        color: #666;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        /* 166.667% */
      }
    }
  
    // .box:hover {
    //   box-shadow: 0px 4px 20px 0px rgba(204, 204, 204, 0.6);
  
    //   .label {
    //     color: #e50009;
    //   }
    // }
  }
  
  .detail_container {
    //display: flex;
    //position: relative;
    //justify-content: center;
    //align-items: flex-start;
    //gap: 24px;
    //flex: 1 0 0;
    display: grid;
    grid-template-columns: 200px 1fr;
    grid-gap: 24px;
    margin: 0 auto;
  
    max-width: 1280px;
  
    section {
      > div {
        position: sticky;
        top: 200px;
      }
  
      align-self: stretch;
  
      h5 {
        color: var(---333, #333);
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px; /* 140% */
      }
  
      >>> .el-menu-item {
        span {
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px; /* 150% */
        }
      }
  
      .el-menu-item.is-active {
        color: #d7000f;
      }
    }
  
    main {
    }
  }
  
  .solution-container {
    width: 1280px;
    margin: 0 auto;
  
    .solution-head {
      width: 100%;
      margin-top: 50px;
  
      .solution-head-title {
        display: inline-flex;
        padding: 0px 0 10px 0;
        margin-top: 60px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        font-size: 16px;
      }
  
      .active {
        color: var(--color-primary, #e10009);
        // border-bottom: 2px solid var(--color-primary, #d7000f);
      }
    }
  
    .solution-contant {
      max-width: 1440px;
      margin-bottom: 100px;
      .solution-contant-title {
        height: 45px;
        margin-bottom: 20px;
        font-weight: 500;
        color: #000000;
  
        :first-child {
          display: inline-block;
          width: 3px;
          height: 20px;
          background: #e50009;
          margin-right: 5px;
        }
  
        span {
          font-size: 32px;
        }
      }
  
      //
      //.card-text-title {
      //  width: 80%;
      //  font-size: 16px;
      //  font-weight: 500;
      //  color: #131415;
      //  margin-left: 10px;
      //  white-space: nowrap;
      //  overflow: hidden;
      //  text-overflow: ellipsis;
      //}
      //
      //.card-text-desc {
      //  width: 80%;
      //  height: 65px;
      //  font-size: 16px;
      //  font-weight: 400;
      //  color: rgba(19, 20, 21, 0.70);
      //  margin: 10px;
      //  word-break: break-all;
      //  text-overflow: ellipsis;
      //  overflow: hidden;
      //  display: -webkit-box;
      //  -webkit-line-clamp: 3;
      //  -webkit-box-orient: vertical;
      //}
      //
      //.card-text-icon {
      //  margin-left: 10px;
      //  margin-bottom: 10px;
      //  color: #E50009;
      //  cursor: pointer;
      //}
    }
  }
  </style>
  
  


// WEBPACK FOOTER //
// src/components/fangan.vue